import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteMurau() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-murau-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-murau-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="murau" />
      </div>
    </div>
  );
}

export default BodenfeuchteMurau;
